import { createMapAction } from "chalet-shared";

export const actionCreators = {
    redirectToUrl: createMapAction("REDIRECT_TO_URL", (x: { url: string }) => x),
};
